<template>
  <div class="position-r box">
    <!--banner-->
    <div class="index-banner"
      style="background-image: url(https://pyh-test.oss-cn-chengdu.aliyuncs.com/images/2021-08-26/8aa8c11e8b9e409cb555fe61151437e8-f3d8e3c697b27992b88f0a134978cde.jpg)"
      @click="goToUrl">
      <div class="f24 fw">欢迎使用</div>
      <div class="f24 fw"><span class="color-09">爱格汇</span>共享轮椅</div>
      <div class="pt5 flex-fs">
        <div class="mr8 photo-icon">
          <img :src="headPhoto" alt="" class="head-img" />
        </div>
        <span>{{ userName }}</span>
      </div>
    </div>
    <div class="flexJC p15" style="margin-top: -60px;">
      <div class="" v-show="isMz == false">
        <!--租借-->
        <div class="content-box" v-show="isNormal == 1 && isBackBed == false">
          <div class="flexJC alignItem">
            <div class="flex-fs fw">
              <i class="icon-con icon_lb"></i>
              <span class="f16 color-3 mt-3">{{
        filterFun(cabinetInfo && cabinetInfo.cabinet.placeName)
      }}</span>
            </div>
            <h3 class="f20 color-3 pt10">
              可用轮椅仅剩<span class="color-09">{{ number }}</span>台
            </h3>
            <div class="bed-img pt10 pb15">
              <img src="../../../static/images/wheelchair.png" alt="" />
            </div>
            <div class="flexJC text-left">
              <div class="items-center row text-left">
                <div style="font-size:1.2em" class="pb5">计费规则</div>
              </div>
              <p class="color-red pt5">
                {{ rule && rule.chargeRule }}
              </p>
            </div>
            <div class="mt10 flex flexJC alignItem" style="width: 80%">
              <button class="btn-lx btn-lx-width mb10" :disabled="number == 0 || isDisabled == true"
                :class="(number == 0 || isDisabled == true) ? 'unSubmit' : 'btn-width'"
                v-if="isNormal == 1 && isBackBed == false" @click="postZmGrant">免押租借</button>
            </div>
            <div class="flexJC alignItem" v-if="isNormal === 1 && isBackBed === false">
              <div class="flex-fs f12" style="height: 15px">
                <img class="zm-logo" src="../../assets/zmlogo.png" />
                &nbsp;
                <div class="zm-text">芝麻信用分 | 600分及以上优享</div>
              </div>
            </div>
            <div class="flex-fs pt10">
              <router-link tag="div" to="/agreement" class="f10 color-9 mr10">用户协议</router-link>
            </div>
          </div>
        </div>

        <!--设备异常-->
        <div class="content-box" v-show="isNormal == 0">
          <div class="flexJC alignItem text-over">
            <div class="flex-fs fw">
              <i class="icon-con icon_lb"></i>
              <span class="f16 color-3 text-over mt-3">{{
        placeName
      }}</span>
            </div>
            <div class="pt18">
              <div class="noNormal">
                <img src="../../../static/images/icon_noNarmal.png" alt="" />
              </div>
              <div class="f16 color-9 pt10" style="width:100%;white-space:normal;">
                {{ errorMessage }}
              </div>
              <div class="f16 color-9 pt10">
                <p>为您带来的不便我们深表歉意</p>
              </div>
            </div>
          </div>
          <div class="flex mt36">
            <a href="tel:400-688-9528" class="btn-lx btn-lx-width">联系客服</a>
          </div>
        </div>
      </div>
    </div>
    <div class="p15" v-show="isBackBed == false">
      <div class="banner">
        <mt-swipe :auto="8000">
          <mt-swipe-item>
            <div class="cabinet-box flexJC alignItem cabinet-content" @click="goToUrl">
              <div class="fw f20">
                <span class="ml10">押金归还即退</span>
              </div>
              <div class="f14">
                预收金额<span class="f14 color-09">{{
        cabinetInfo && cabinetInfo.cabinet.depositMoney
          ? cabinetInfo.cabinet.depositMoney
          : 0
      }}</span>元 <span>芝麻分601以上支付宝扫码免押</span>
              </div>
            </div>
          </mt-swipe-item>
          <mt-swipe-item v-for="item in bannerList" :key="item.advNo">
            <a @click="goToNewUrl(item.outerUrl)" class="displsy-block banner-a"><img :src="item.advUrl" alt=""
                class="border-radius" /></a>
          </mt-swipe-item>
        </mt-swipe>
      </div>
    </div>
    <div class="p15">
    </div>
    <!--弹框-->
    <div class="shade" v-show="hasMore">
      <div class="flexJC alignItem showLoading">
        <img src="../../../static/images/Spinner_1.gif" alt="" class="icon_loading" />
      </div>
    </div>
    <div class="system-upgrade-modal">
      <div class="modal-content">
        <p>系统正在升级中，请稍后再试。</p>
      </div>
    </div>
    <div v-html="html"></div>
  </div>
</template>

<script>
import wxServ from "../../service/wxServ";
import cache from "../../service/cacheServ";
import userServ from "../../service/userServ";
import cabinetServ from "../../service/cabinetServ";
import mintUi from "../../lib/mint-ui";
import moment from "moment";
import zfvServ from "../../service/zfbServ";
import log from '../../lib/log'
import preventBack from 'vue-prevent-browser-back'
export default {
  mixins: [preventBack], //禁止返回上一页
  data() {
    return {
      queryCount: 0,
      headPhoto: "/static/images/touxiang@2x.png",
      userName: "",
      isLoading: true,
      isNormal: null,
      cabinetInfo: null,
      number: null,
      qrCode: null,
      bedNo: null,
      hasMore: false,
      isBackBed: null,
      list: null,
      wxId: null,
      giveBackList: null,
      alipayWap: null,
      html: "",
      isDisabled: false,
      isZm: false,
      bannerList: [],
      timerList: [],
      isMz: null,
      errorMessage: "",
      placeName: "",
      rule: {}
    };
  },
  created() {
    let qrCode = this.$route.query.qrcode;
    let bedNo = this.$route.query.bedNo;
    console.log("qrcode:" + this.$route.query.qrcode);
    this.qrCode = qrCode;
    this.bedNo = bedNo;
    let userInfo = cache.get("user");
    if (userInfo && qrCode) {
      this.userName = userInfo.customerName;
      this.headPhoto = userInfo.headImgUrl
        ? userInfo.headImgUrl
        : "/static/images/touxiang@2x.png";
      //this.getIsBedFun(userInfo.openId);
      this.wxId = userInfo.openId;
      this.queryCabinetOrderInfo(this.wxId, qrCode, this.bedNo)
      //this.getCabinetSta(qrCode);
      this.getBannerList("HOME");
    }
  },
  methods: {
    queryCabinetOrderInfo(customerWxId, qrCode, bedNo) {
      this.isBackBed = false;
      this.isMz = false;
      let that = this;
      mintUi.Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle',
      });
      cabinetServ.queryCabinetOrderInfo(customerWxId, qrCode, bedNo).then(function (res) {
        mintUi.Indicator.close();
        if (res.code === "200") {
          that.rule = res.data.rule;
          that.cabinetInfo = res.data;
          if (res.data.bedStructList) {
            let newList = res.data.bedStructList.filter((item, index) => item.status === 1 && res.data.doorStatus[index] === 1);
            that.number = newList ? newList.length : 0;
          }
          that.isNormal = 1;
          cache.set("cabinetInfo", res.data, true);
          //that.getTimeList(that.qrCode);
        } else {
          that.number = 0;
          that.isNormal = 0;
          that.errorMessage = res.message || "服务器开小差，请稍后再试";
          that.placeName = res.data || ""
          cache.set("cabinetInfo", {}, true);
          that.queryCount++;
          if (that.queryCount < 6) {
            setTimeout(() => {
              that.queryCabinetOrderInfo(customerWxId, qrCode, bedNo)
            }, 5000 * that.queryCount);
          }
        }
      })
    },
    goToUrl() {
      window.location.href = "http://www.aigehui028.com/";
    },
    /* 免押租借*/
    postZmGrant() {
      if (this.number == 0 || this.isZm == true) return;
      this.isDisabled = true;
      var that = this;
      zfvServ.postZmGrantFun(this.wxId, this.qrCode, this.bedNo).then((res10) => {
        if (200 === +res10.code) {
          let baseUrl = window.location.origin;
          var orderId = res10.data.grantOrderNo;
          let qrCode = this.$route.query.qrcode;
          let bedNo = this.$route.query.bedNo;
          let openId = cache.get("user").openId;
          ap.tradePay(
            {
              orderStr: res10.data.orderStr,
            },
            function (res) {
              if (res.resultCode === "9000") {
                window.location.href =
                  baseUrl +
                  "/#/alipayPaySuccess?orderNo=" +
                  orderId +
                  "&openId=" +
                  openId +
                  "&qrcode=" +
                  qrCode + "&bedNo=" + bedNo;
              } else if (res.resultCode === "4000") {
                mintUi.Toast({
                  message: "支付失败",
                  position: "bottom",
                  duration: 4000,
                });
                that.isDisabled = false;
              } else if (res.resultCode === "6002") {
                mintUi.Toast({
                  message: "网络连接出错",
                  position: "bottom",
                  duration: 4000,
                });
                that.isDisabled = false;
              } else if (res.resultCode === "6001") {
                zfvServ.postCancelZmFun(orderId, openId, qrCode, bedNo).then((res20) => {
                  mintUi.Toast({
                    message: "取消支付",
                    position: "bottom",
                    duration: 4000,
                  });
                });
                that.isDisabled = false;
              }
            }
          );
        } else {
          mintUi.Toast({
            message: res10.message,
            position: "bottom",
            duration: 4000,
          });
          setTimeout(() => {
            that.isZm = false;
          }, 4000);
        }
      });
    },
    filterFun: function (value) {
      if (value && value.length > 13) {
        value = value.substring(0, 13) + "...";
      }
      return value;
    },
    // 获取广告
    getBannerList(position) {
      wxServ.getBanner(position).then((res) => {
        if (res.code === "200") {
          this.bannerList = res.data;
        } else {
          mintUi.Toast({
            message: res.message,
            position: "bottom",
          });
        }
      });
    },
    goToNewUrl(url) {
      if (url) {
        window.location.href = url;
      } else {
        return false;
      }
    },
  },
  mounted() {
    // this.getCabinetSta(this.qrCode)
  },
};
</script>

<style lang="less" scoped>
@import "../../less/_var.less";
@import "../../less/index.less";

.index-banner {
  padding: 26px 25px 0 25px;
  text-align: left;
  color: #fff;
  background-size: 100% 100%;
  height: 214px;
}

.pt5 {
  padding-top: 5px;
}

.loadingImg {
  width: 100px;
  height: 100px;
}

.loading-con {
  width: 70%;
  margin-left: -35%;
}

.banner {
  height: 120px;
}

.banner img {
  width: 100%;
  height: 100%;
}

.photo-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
}

.photo-icon img {
  width: 100%;
  height: 100%;
}

.userInfo {
  position: absolute;
  left: 90px;
  top: 15px;
  right: 16px;
}

.zm-logo {
  height: 100%;
}

.zm-text {
  color: #666;
  font-family: PingFang;
  font-size: 11px;
}

.icon_lb {
  background: url("../../../static/images/icon_position.png") no-repeat;
  background-size: 100% 100%;
  width: 14px;
  height: 16px;
}

.bed-img {
  width: 177px;
  height: 177px;
}

.bed-img img {
  // width: 100%;
  width: auto;
  height: 100%;
  margin: auto;
}

.icon-fy {
  background: url("../../../static/images/icon_fy.png") no-repeat;
  background-size: 100% 100%;
  width: 22px;
  height: 22px;
}

.mt-3 {
  margin-top: -2px;
}

.icon-sb {
  background: url("../../../static/images/icon_sb.png") no-repeat;
  background-size: 100% 100%;
  width: 22px;
  height: 22px;
}

.icon_loading {
  width: 60px;
  height: 60px;
}

.head-img {
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
}

.unSubmit {
  background-color: #808080;
  color: #fff;
  border-color: #808080;
}

.system-upgrade-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  width: 80%;
  max-width: 400px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease-in-out;
}

.modal-content p {
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10%);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/alipay/alipayIndex.vue